import { render, staticRenderFns } from "./AddNewCard.vue?vue&type=template&id=315f28f4&scoped=true"
import script from "./AddNewCard.vue?vue&type=script&lang=js"
export * from "./AddNewCard.vue?vue&type=script&lang=js"
import style0 from "./AddNewCard.vue?vue&type=style&index=0&id=315f28f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315f28f4",
  null
  
)

export default component.exports